import script from "./StatusUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusUpdate.vue?vue&type=script&setup=true&lang=js"

import "./StatusUpdate.vue?vue&type=style&index=0&id=dc3c79cc&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc3c79cc"]])

export default __exports__